
      import serviceWorkerRegisterer from "./src/service-worker/registerer.ts";

      (async () => {
        await serviceWorkerRegisterer();
        import("./src/index.tsx");
      })();
    